import { useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Drawer } from "cerulean";

import MerchantDetails from "../MerchantDetails";

const MerchantDetailsDrawer = ({ cardId }: { cardId: API.CardId }) => {
  const { subscriptionUuid } = useParams<{
    subscriptionUuid?: string;
  }>();
  const navigate = useNavigate();
  const handleDrawerClose = useCallback(
    () => navigate(`/cards/${cardId}/subscriptions`, { replace: true }),
    [cardId, navigate]
  );

  if (!subscriptionUuid) {
    return null;
  }

  return (
    <Drawer
      depth="470px"
      isOpen={true}
      onUserDismiss={handleDrawerClose}
      showControls={false}
      paddingSize="none"
    >
      <MerchantDetails cardId={cardId} subscriptionUuid={subscriptionUuid} />
    </Drawer>
  );
};

export default MerchantDetailsDrawer;
